import { Card, CardProps } from 'antd'
import styled from 'styled-components'

const CustomCard = styled(Card)`
  border-radius: ${({ theme }) => theme.borderRadius.medium};

  & > .ant-card-body {
    padding: 1.25rem;
  }

  & .ant-tabs-top {
    margin-top: -1.25rem;
  }
`

type Props = CardProps & {
  bodyStyle?: object
  marginTop?: string
}

export const DesktopCard: React.FC<Props> = ({
  style,
  marginTop,
  children,
  ...rest
}) => {
  return (
    <CustomCard bordered style={{ marginTop, ...style }} {...rest}>
      {children}
    </CustomCard>
  )
}
